import React from "react";
import { Facebook, MessageCircle, Mail } from "lucide-react";
import { FUNCHESTER_LOGO } from "@/config";

const Footer = () => (
  <footer className="footer">
    <div className="container footer-content">
      <img src={FUNCHESTER_LOGO} alt="Funchester TV" className="footer-logo-img" />
      <div className="footer-logo">
        Funchester <span>TV</span>
      </div>
      <p className="footer-text">Your Home for Kentucky Wildcats Basketball</p>
      <p className="footer-text">Go Big Blue!</p>
      <div className="footer-links">
        <a href="https://www.facebook.com/groups/979251609124467" target="_blank" rel="noopener noreferrer" className="footer-social">
          <Facebook size={20} />
        </a>
        <a href="https://discord.gg/uWACEZVW5K" target="_blank" rel="noopener noreferrer" className="footer-social" data-testid="footer-discord">
          <MessageCircle size={20} />
        </a>
        <a href="mailto:Funchesterteevee@gmail.com" className="footer-social">
          <Mail size={20} />
        </a>
      </div>
      <p className="footer-copyright">&copy; {new Date().getFullYear()} Funchester TV. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
